"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewDcCreateAccount extends new_item_1.default {
    constructor(newDcCreateAccount) {
        super();
        this.emailAddress = newDcCreateAccount.emailAddress;
        this.password = newDcCreateAccount.password;
    }
}
exports.default = NewDcCreateAccount;
//# sourceMappingURL=new-dcCreateAccount.js.map